import styled, { css } from "styled-components";
import { Checkbox, Flex, Slider } from "@evergis/ui";

import { IconContainer } from "../../../LayerList/styled";
import { PopupContainer } from "../../../Map/components/GeometrySelectionTools/styled";
import { MapControlContainer } from "../../styled";

export const SnappingMapControl = styled(MapControlContainer)`
  height: 2.5rem;
  animation-duration: 0.3s;
  animation-name: slideDown;
  animation-timing-function: ease-in;

  @keyframes slideDown {
    from {
      margin-top: -3.5rem;
    }

    to {
      margin-top: 0;
    }
  }
`;

export const CenteredContent = styled.div`
  margin: 0 auto;
`;

export const SnappingContainer = styled.div`
  width: 20rem;
  height: auto !important;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  background: ${({ theme: { palette } }) => palette.panelBackground};
  backdrop-filter: blur(10px);
`;

export const SnappingTitleContainer = styled(Flex)`
  width: 100%;
  align-items: center;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
  flex-wrap: nowrap;
`;

export const SnappingListControlsContainer = styled(SnappingTitleContainer)`
  padding-top: 0;
  padding-bottom: 5px;
  flex-shrink: 0;
`;

export const SnappingTitle = styled.div`
  font-size: 18px;
  color: ${({ theme: { palette } }) => palette.textPrimary};
  font-weight: 400;
`;

export const SnappingControlsContainer = styled(Flex)`
  align-items: center;
  margin-left: auto;
`;

export const SnappingLayerLabel = styled.label`
  font-size: 12px;
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin-right: 0.5rem;
`;

export const SnappingLayersList = styled(Flex)<{ visible: boolean; loading: boolean }>`
  width: 100%;
  border-top: 2px solid rgba(255, 255, 255, 0.12);
  flex-direction: column;
  flex-wrap: nowrap;
  max-height: 16.5rem;
  overflow-y: auto;
  box-sizing: border-box;

  ${({ visible }) =>
    !visible &&
    css`
      visibility: hidden;
      height: 0;
    `}
  ${({ loading, visible }) =>
    loading &&
    visible &&
    css`
      padding: 0.5rem 1.5rem 0.5rem 1rem;
    `}
`;

export const SnappingLayerItemContainer = styled(Flex)`
  width: 100%;
  padding: 0.75rem 0.25rem 0.75rem 1rem;
  box-sizing: border-box;
  flex-wrap: nowrap;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.12);
  }
`;

export const SnappingLayerIconContainer = styled(IconContainer)`
  margin-right: 0rem;
`;

export const SnappingLayerNameContainer = styled.div`
  padding-left: 1rem;
  padding-right: 0.5rem;
  width: 8rem;
  box-sizing: border-box;
`;

export const SnappingLayerName = styled.div`
  width: 100%;
  min-width: 1px;
  font-size: 12px;
  color: ${({ theme: { palette } }) => palette.textPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SnappingCheckbox = styled(Checkbox)`
  margin-right: 10px;
  width: 1rem;
`;

export const SnappingLayerNameText = styled.span<{ highlight?: boolean }>`
  color: ${({ highlight, theme: { palette } }) => (highlight ? palette.primary : palette.textPrimary)};
`;

export const SnappingTypes = styled(Flex)`
  align-items: center;
  flex-wrap: nowrap;
`;

export const SettingsMenuContainer = styled(PopupContainer)`
  flex-direction: column;
  padding: 1.5rem;
  box-sizing: border-box;
  width: 23.5rem;
  top: -0.5rem;
  left: 0;
`;

export const SettingsMenuCheckbox = styled(Checkbox)`
  white-space: nowrap;
  margin-bottom: 1rem;
  user-select: none;
`;

export const SettingsMenuLabel = styled.label`
  font-size: 12px;
  color: ${({ theme: { palette } }) => palette.textPrimary};
  margin-top: 1rem;
  margin-left: 0.5rem;
  margin-bottom: 0.25rem;
`;

export const SnappingDistanceSliderContainer = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  flex-wrap: nowrap;
`;

export const SnappingDistanceSlider = styled(Slider)`
  width: 11.5rem;
  margin-right: 1rem;
`;
